import { siteSettings } from "core/siteSettings";

export function generateGuid() {
  var result, i, j;
  result = "";
  for (j = 0; j < 32; j++) {
    if (j === 8 || j === 12 || j === 16 || j === 20) result = result + "-";
    i = Math.floor(Math.random() * 16)
      .toString(16)
      .toUpperCase();
    result = result + i;
  }
  return result;
}

export async function transformInternalUrl(url) {
  // https://insight-scalars-dev.onyxinsight.fail/api/events/167/attachments/Screenshot%20from%202020-11-20%2012-21-11.png
  const protocolPos = url.indexOf("http");
  const apiPathSegmentPos = url.indexOf("/api/");
  const al = "/api".length;

  if (protocolPos === -1 || apiPathSegmentPos === -1) {
    return url;
  }

  const needle = url.substring(protocolPos, apiPathSegmentPos + al);
  const baseUrl = siteSettings.siteApiURL;
  return url.replace(needle, baseUrl);
}

// So from the name "Daniel Griffiths", this would return the string "DG"
export function getInitialsFromName(name) {
  return name
    .split(" ")
    .map(x => x[0])
    .join("");
}

export const caseIdToDisplayId = caseId => {
  const pad = new Array(7).join("0");
  return `C${(pad + caseId).slice(-pad.length)}`;
};

export function isEmpty(val) {
  return val ? !val.trim() : true;
}
